export default __webpack_public_path__ + "static/icon-cd2ae949cdb22488df59999b2add3e1d.png";